import { render, staticRenderFns } from "./UpgradeCore.vue?vue&type=template&id=337418d4&scoped=true&"
import script from "./UpgradeCore.vue?vue&type=script&lang=js&"
export * from "./UpgradeCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337418d4",
  null
  
)

export default component.exports